export const mm2inch = (mm: number) => mm / 25.4;

